import React from 'react';

const TherapyServicesContent = () => {
  return (
    <>
      {/* Orange Line */}
      <div className="orange-line"></div>

      {/* Panel 1 - Therapy Services Introduction (Beige Background) */}
      <div className="py-12 sm:py-14 lg:py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f2f4f7' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
            {/* Left Column - Main Content */}
            <div className="lg:col-span-2">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-6 sm:mb-8" style={{ color: '#2b3d57' }}>
                Therapy Services
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
                Our Therapy Services are designed to support children and young people with complex and varied needs to
                recover, develop, and move forward with confidence. Through careful assessment and skilled therapeutic
                input, we help young people rebuild their lives within a safe, nurturing, and professionally supported
                environment, always keeping the child at the centre of everything we do.
              </p>
              <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
                We deliver personalised therapeutic packages, tailored to each child's individual needs and
                circumstances. Our comprehensive therapy and assessment offer can be commissioned as a standalone
                service or alongside a wider care plan, ensuring consistency and continuity across all areas of
                support.
              </p>
              <p className="text-base mb-7 sm:mb-8 leading-relaxed" style={{ color: '#2b3d57' }}>
                To find out more about our Therapy Services, please get in touch with our team or explore the website
                for further information.
              </p>
              <h4 className="text-2xl font-semibold mb-2" style={{ color: '#2b3d57' }}>
                Rebecca Bracey
              </h4>
              <p className="text-sm" style={{ color: '#2b3d57' }}>
                Clinical Lead, Testa Care
              </p>
            </div>

            {/* Right Column - Mission Statement */}
            <div className="lg:col-span-1 lg:border-l-2 lg:border-dotted lg:border-gray-400 lg:pl-12">
              <div className="bg-white p-5 sm:p-6 rounded-lg shadow-sm">
                <h2 className="text-2xl sm:text-3xl font-light mb-4" style={{ color: '#2b3d57' }}>
                  Mission
                </h2>
                <p className="text-base sm:text-lg leading-relaxed" style={{ color: '#2b3d57' }}>
                  To provide compassionate, therapeutic residential care that empowers vulnerable children and young
                  people to heal, grow, and achieve their full potential.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Panel 2 - What is YP-MATS (White Background) */}
      <div className="py-12 sm:py-14 lg:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
            {/* Left Column - Main Content */}
            <div className="lg:col-span-2">
              <h1 className="text-[22px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-light mb-6 sm:mb-8 leading-snug tracking-tight max-w-3xl" style={{ color: '#2f4c74' }}>
                <span className="block">What are Testa Care's Multi-Disciplinary Assessment and Therapy Services?</span>
              </h1>
              <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
                Our Therapy Services bring together the knowledge and skills of a team of professionals to assess, plan, and coordinate therapy for the young people in our care. This collaborative approach ensures that each child or young person has access to the most effective therapeutic support tailored to their individual needs.
              </p>
              <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
                At Testa Care, we believe that timely and well-structured clinical and therapeutic interventions can have a profound impact on a young person's life. Most importantly, we support young people in developing the understanding and maturity to make healthier choices for themselves.
              </p>
              <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
                If you would like to learn more about the services we offer, please feel free to get in touch or explore our website for further information.
              </p>
            </div>

            {/* Right Column - Assessment Card */}
            <div className="lg:col-span-1 lg:border-l-2 lg:border-dotted lg:border-gray-400 lg:pl-12">
              <div className="bg-gray-50 p-5 sm:p-6 rounded-lg">
                <h2 className="text-2xl sm:text-3xl font-light mb-4" style={{ color: '#2b3d57' }}>
                  Assessment
                </h2>
                <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
                  We offer personalised therapeutic packages tailored to meet the unique needs of each young person,
                  ensuring support that is specific, relevant, and effective.
                </p>
                <a
                  href="/therapy-services/assessments"
                  className="inline-block px-8 py-3 rounded-full border-2 transition duration-300 hover:bg-orange-500 hover:text-white"
                  style={{ borderColor: '#2f4c74', color: '#2b3d57' }}
                >
                  Find out more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Panel 3 - Why The Need For YP-MATS (Beige Background) */}
      <div className="py-12 sm:py-14 lg:py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f2f4f7' }}>
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl">
            <h1 className="text-[26px] sm:text-[30px] md:text-[34px] lg:text-[38px] font-light mb-6 sm:mb-8 leading-snug tracking-tight max-w-3xl" style={{ color: '#2f4c74' }}>
              <span className="block">Why Multi-Disciplinary Assessment</span>
              <span className="block">and Therapy Services Matter?</span>
            </h1>
            <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
              We know that timely, targeted clinical and therapeutic support can make a transformative difference in a
              young person's life. It equips them with the insight, resilience, and skills to make positive, healthy
              choices.
            </p>
            <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
              Our mission is to support children and young people with complex and diverse needs through comprehensive
              assessments and tailored therapeutic guidance, helping them rebuild their lives within a safe, nurturing,
              and professionally supported environment.
            </p>
          </div>
        </div>
      </div>

      {/* Panel 4 - Our Team (White Background) */}
      <div className="py-12 sm:py-14 lg:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-6 sm:mb-8" style={{ color: '#2b3d57' }}>
              Our Team
            </h1>
            <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
              We take a multi-disciplinary approach, ensuring every young person's therapy plan is shaped by the
              expertise of both clinical and non-clinical team members.
            </p>
            <p className="text-base mb-5 sm:mb-6 leading-relaxed" style={{ color: '#2b3d57' }}>
              Our team includes Chartered Clinical and Forensic Psychologists, Psychiatrists, Occupational Therapists,
              Play Therapists, Psychotherapists, CAMHS Nursing Specialists, Family Therapists, and Art Therapists. This
              collaborative model enables us to match each child with the most appropriate professional, delivering
              personalised and effective support tailored to their individual needs.
            </p>
          </div>
        </div>
      </div>

      {/* CTA Grid - Edge to Edge */}
      <div className="bg-white w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
        <div className="flex lg:grid lg:grid-cols-2 gap-0 bg-white overflow-x-auto lg:overflow-visible w-full snap-x snap-mandatory">
          {/* Assessments Card */}
          <a
            href="/therapy-services/assessments"
            className="cta group relative block h-96 w-full min-w-full lg:min-w-0 flex-none overflow-hidden snap-start"
          >
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
              style={{ backgroundImage: "url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=2000&q=80')" }}
            ></div>

            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-30 transition-all duration-300"></div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-white p-8">
              <img
                src="/assets/images/logo12.png"
                alt="Testa Care logo"
                className="h-28 w-80 mx-auto mb-4 object-contain scale-150"
                loading="lazy"
              />
              <h3 className="text-3xl font-light text-center">
                Assessments
              </h3>
            </div>
          </a>

          {/* Interventions Card */}
          <a
            href="/therapy-services/interventions"
            className="cta group relative block h-96 w-full min-w-full lg:min-w-0 flex-none overflow-hidden snap-start"
          >
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
              style={{ backgroundImage: "url('/assets/images/interventions.jpeg')" }}
            ></div>

            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-30 transition-all duration-300"></div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-white p-8">
              <img
                src="/assets/images/logo12.png"
                alt="Testa Care logo"
                className="h-28 w-80 mx-auto mb-4 object-contain scale-150"
                loading="lazy"
              />
              <h3 className="text-3xl font-light text-center">
                Interventions
              </h3>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default TherapyServicesContent;
